import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PointRaceDto, RaceDetailDto, RaceStatusEnum, RankingDto, resultStatusLabel, RunnerStatusEnum, runnerStatusLabel } from "@aoe/client";
import * as _ from 'lodash-es';
import { map, Observable, shareReplay, switchMap, tap, timer } from 'rxjs';
import { formatShortestDate, timestampToTimeString } from 'src/app/core/helpers/Date.helpers';
import { PassagesRankingItem, RunnerRankingItem } from 'src/app/core/interfaces/item/RankingItem.interface';
import { FilterRankModule } from 'src/app/core/pipe/filter-rank/filter-rank.module';
import { DialogService } from 'src/app/core/services/dialog.service';
import { RaceService } from 'src/app/core/services/race.service';
import { RankingService } from 'src/app/core/services/ranking.service';


@Component({
  selector: 'aoe-ranking',
  templateUrl: './ranking.component.html',
  styleUrls: ['./ranking.component.scss'],
  imports: [CommonModule, FormsModule, FilterRankModule]
})
export class RankingComponent implements OnInit {

  @Input()
  race!: RaceDetailDto;

  @Input()
  eventId!: string;

  @Input()
  points!: Array<PointRaceDto>;

  public ranking$: Observable<RankingDto[]> = new Observable<RankingDto[]>();
  public startList!: Array<RunnerRankingItem>;
  public getRunnerStatusLabel = runnerStatusLabel;
  public resultStatusLabel = resultStatusLabel;
  public searchTerm: string = '';
  public nbRanked = 0;
  public nbRegistred!: number;

  public formatTime = timestampToTimeString;

  hasRanking$: Observable<boolean> = this.ranking$.pipe(
    map(rankings => !!rankings && rankings.length > 0)
  );


  constructor(
    private readonly rankingService: RankingService,
    private readonly raceService: RaceService,
    private readonly dialogServie: DialogService,
  ) { }

  ngOnInit(): void {
    this.ranking$ = timer(0, 120000).pipe(
      // Annotation explicite du type de retour ici : Observable<RankingDto[]>
      switchMap((): Observable<RankingDto[]> => {

        // 1. Course non démarrée
        if (this.race.status === RaceStatusEnum.NOT_STARTED) {
          return this.raceService.getStartList(this.race.id, this.eventId).pipe(
            map((res: any) => (res.data?.runners.map((r: any) => ({ runner: r })) ?? []) as RankingDto[])
          );
        }

        // 2. Course en cours / terminée
        return this.rankingService.getRanking(this.race.id, false, this.eventId).pipe(
          map((res: any) => (res.data?.rankings ?? []) as RankingDto[]),
          tap((rankings: RankingDto[]) => this.nbRanked = rankings.length)
        );
      }),
      shareReplay(1)
    );

    console.log(this.ranking$);

  }

  public getCountryFlagUrl(countryCode: string): string {
    if (countryCode)
      return `https://flagcdn.com/${countryCode.slice(0, 2).toLowerCase()}.svg`;
    return ''
  }

  public getPassageDateTime(pointId: number, passages: Array<PassagesRankingItem>) {
    const passage = _.find(passages, ['pointId', pointId])
    if (passage)
      return formatShortestDate(new Date(passage.dateTime));
    return '-'
  }


  public hisFinisher(r: RankingDto): boolean {
    // if (r.runner) {
    return r.runner?.status === RunnerStatusEnum.FINISHER;
    // } else {
    //   return r.team.status === RunnerStatusEnum.FINISHER;
    // }
  }

  get isOnRankingMode(): boolean {
    return this.race.status !== RaceStatusEnum.NOT_STARTED;
  }

  get displaySpeed(): boolean {
    return this.race.rankingSpeed ?? false;
  }

  get isTeamRace(): boolean {
    return !!this.race.isTeamRace;
  }

  get resultsStatus() {
    return this.race.resultStatus;
  }

  get raceStatus() {
    return this.race.status;
  }


  public displayNextPoint(r: RankingDto): boolean {
    if (r.runner)
      return r.runner.status === RunnerStatusEnum.ON_RACE;

    // if (r.team)
    //   return r.team.status === RunnerStatusEnum.ON_RACE;

    return false;
  }

  public displayRunnerData(r: RankingDto) {
    if (this.isOnRankingMode)
      this.dialogServie.openRunnerModal(r, this.points as any, this.race);
  }

  getRank(r: RankingDto): string | number {
    if (r.runner) {
      if (r.runner.status) {
        if (!_.isNull(r.rank))
          if (!!r.rank.scratch) {
            return r.rank.scratch;
          } else {
            return ''
          }

        switch (r.runner.status) {
          case RunnerStatusEnum.ABANDONED:
            return 'DNF';

          case RunnerStatusEnum.DID_NOT_START:
            return 'DNS'

          default:
            return ''
        }
      }
    }

    // if (r.team) {
    //   if (r.team.status) {
    //     if (!_.isNull(r.rank))
    //       return r.rank.scratch;
    //     return r.team.status === RunnerStatusEnum.ABANDONED ? 'DNF' : _.upperCase(r.team.status);
    //   }
    // }

    return '-';
  }

}
